import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/rechargeLog',
  title: window.language['menu.client.rechargeLog'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('../../System/Org/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Client/RechargeLog/index.js